import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { I18nProvider } from './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>
);
